<template>
  <div>
    <div class="table-wrapper orders-history">
      <section class="section">
        <div class="section-contents pt-1">
          <div class="row">
            <div class="col-lg-12 profile-details">
              <h2 class="cp-title">Your Wishlist</h2>
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Picture</th>
                      <th scope="col">Name</th>
                      <th scope="col">ISBN</th>
                      <th scope="col" class="text-right">Unit Price</th>
                      <th scope="col" class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in wishlist"
                      v-bind:key="key"
                      class="wishlist-row"
                    >
                      <td>
                        <a :href="`${baseUrl}book/${item.product.id}`">
                          <img
                            v-bind:src="
                              `${IMAGEURL}${item.product.image}`
                            "
                            class="img-responsive"
                            style="    max-height: 60px;"
                          />
                        </a>
                      </td>
                      <td>
                        <span v-if="item.product.product_name.length < 14">
                          {{ item.product.product_name }}
                        </span>
                        <span
                          v-if="item.product.product_name.length >= 14"
                          :title="`${item.product.product_name}`"
                        >
                          {{ item.product.product_name.substr(0, 14) + "..." }}
                        </span>
                      </td>
                      <td>{{ item.product.isbn }}</td>
                      <td class="text-right">
                        <span class="currency">৳</span> {{ item.product.price }}
                      </td>
                      <td class="text-center">
                        <button
                          @click="addToCart(item, $event)"
                          class="btn btn-warning btn-xs mr-1"
                        >
                          <i class="fa fa-shopping-cart"></i> Add to Cart
                        </button>
                        <button
                          @click="removeFromWishlist(item)"
                          class="btn btn-danger btn-xs"
                        >
                          <i class="fa fa-trash"></i> Remove
                        </button>
                      </td>
                    </tr>
                    <tr v-if="wishlist.length < 1">
                      <th scope="row" colspan="5">
                        No data found
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "HelloWorld",
  data() {
    return {
      noDataFound: false,
      wishlist: [],
    };
  },
  methods: {
    removeFromWishlist(row) {
      var payload = { id: row.id };
      this.$store.dispatch("deleteFromWishlist", payload);
    },
    getWishList() {
      this.$authHttp
        .get("wish-list")
        .then(response => {
          this.wishlist = response.data.data;
          //console.log(this.wishlist);
        })
        .catch(e => {
          //console.log(e);
        });
    },
    removeFromWishlist(item) {
      let formData = {
        customer_id: localStorage.getItem("customer_id"),
        product_id: item.product.id
      };

      this.$authHttp
        .post("wish-list-delete", formData)
        .then(response => {
          this.flashMessage.success({
            message: "Removed from wishlist successfully."
          });
          this.getWishList();
        })
        .catch(e => {
          //console.log(e);
        });
    },
    addToCart(item, e) {
      let row = item.product;

      // Capture the row thumbnail before the row is removed from the list below.
      let sourceImg = null;
      if (e && e.currentTarget) {
        const tr = e.currentTarget.closest("tr");
        if (tr) sourceImg = tr.querySelector("img");
      }

      let itemObj = {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        image: row.image,
        price: row.price,
        quantity: 1,
        name: row.product_name,
        sale_type: row.sale_type
      };

      // Call saveToCart and get the status and message
      const result = this.$helper.saveToCart(itemObj);

      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);

      if (result.status === 'success') {
        if (window.fbq) {
          fbq('track', 'AddToCart', {
            content_ids: [row.id],
            content_name: row.product_name,
            content_type: 'product',
            value: parseFloat(row.price) || 0,
            currency: 'BDT'
          });
        }
        this.$flyToCart(sourceImg);
        this.flashMessage.success({ message: result.message });
        window.dispatchEvent(new Event("cart-updated"));
      } else if (result.status === 'error') {
          this.flashMessage.error({ message: result.message });
      }

      this.removeFromWishlist(item);
    }
  },
  mounted() {
    this.getWishList();
  }
};
</script>
